export function LoadingPanel({ label = 'Loading radar data…' }: { label?: string }) {
  return <section className="state-panel"><span className="spinner" />{label}</section>;
}

export function ErrorPanel({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : 'An unexpected error occurred.';
  return <section className="state-panel state-panel--error"><strong>Unable to load this view</strong><span>{message}</span></section>;
}

export function EmptyPanel({ message }: { message: string }) {
  return <div className="empty-panel">{message}</div>;
}
